import { useEffect } from 'react';
import siteConfig from '../data/siteConfig.json';

const GoogleAnalytics = () => {
  useEffect(() => {
    const measurementId = siteConfig.analytics.googleAnalyticsMeasurementId.trim();

    if (!measurementId || document.querySelector(`script[src*="${measurementId}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);
  }, []);

  return null;
};

export default GoogleAnalytics;
